import { useApi } from './useApi';
import { url } from '../../utils/confserveur';

export const useResultatsQCM = (sessionId, refresh) => {
  const enabled = sessionId ? undefined : 'not-enabled';
  return useApi(`${url}sessions-qcm/${sessionId}/resultats/`, {}, refresh, enabled);
};
